module.exports = __webpack_public_path__ + "static/media/splash_08.8e2361ec.png";